import { FieldBaseClasses } from '@/components/ui/fieldStyles';
import { cn } from '@/lib/utils';

export function Input({ className, type = 'text', ...props }) {
  return <input type={type} data-slot="input" className={cn(FieldBaseClasses, 'h-12 px-4', className)} {...props} />;
}